import { Link, useNavigate, useLocation } from 'react-router-dom';
import SidebarMenu from 'react-bootstrap-sidebar-menu';
import './styles/AdminNavbar.css';
import { LayoutContext } from '../context/LayoutContext';
import React, { useState, useEffect, useContext, useRef } from 'react';

const menuItems = [
    {
        title: 'Anasayfa',
        icon: 'fa-solid fa-house',
        paths: ['/index'],
        stateKey: 'dashboard',
        submenu: [
            {
                path: '/index',
                icon: 'fa-solid fa-chart-line',
                label: 'Genel Bakış',
            },
        ],
    },

    {
        title: 'Başvurular',
        icon: 'fa-solid fa-file-circle-plus',
        paths: ['/application'],
        stateKey: 'applications',
        submenu: [
            {
                path: '/application',
                icon: 'fa-solid fa-list',
                label: 'Tüm Başvurular',
            },
        ],
    },

    {
        title: 'Kayıtlı Öğrenciler',
        icon: 'fa-solid fa-user-graduate',
        paths: ['/enrollment'],
        stateKey: 'enrollments',
        submenu: [
            {
                path: '/enrollment',
                icon: 'fa-solid fa-users',
                label: 'Öğrenci Listesi',
            },
        ],
    },

    {
        title: 'Dönemler',
        icon: 'fa-solid fa-calendar-alt',
        paths: ['/term'],
        stateKey: 'terms',
        submenu: [
            {
                path: '/term',
                icon: 'fa-solid fa-calendar-week',
                label: 'Dönem Yönetimi',
            },
        ],
    },

    {
        title: 'E-posta',
        icon: 'fa-solid fa-envelope',
        paths: ['/mail'],
        stateKey: 'mail',
        submenu: [
            {
                path: '/mail',
                icon: 'fa-solid fa-paper-plane',
                label: 'Toplu gönderim',
            },
        ],
    },
];

const AdminNavbar = ({ isFixed }) => {
    const { isCollapsed, toggleNavbar, closeNavbar, isMobile } = useContext(LayoutContext);
    const [sectionStates, setSectionStates] = useState({});
    const navigate = useNavigate();
    const location = useLocation();
    const topbarHeightRef = useRef(0);
    const baseMarginTop = 8.2;
    const [openSectionKey, setOpenSectionKey] = useState(null);




    const handleLogout = () => {
        localStorage.removeItem('token');
        navigate('/');
    };



    const toggleSection = (key) => {
        setOpenSectionKey(prevKey => (prevKey === key ? null : key));
    };






    const isActiveMenu = (paths) => paths.some((path) => location.pathname.startsWith(path));

    useEffect(() => {
        if (isMobile) closeNavbar();
    }, [location.pathname, isMobile]);

    useEffect(() => {
        const addPageContainer = document.querySelector('.add-raw-page-container');
        const pageContainer = document.querySelector('.page-container');
        const topbar = document.querySelector('.topbar');
        let isMobileView = window.innerWidth <= 768;

        const handleResize = () => {
            const newIsMobileView = window.innerWidth <= 768;
            isMobileView = newIsMobileView;

            if (pageContainer) {
                pageContainer.style.marginLeft = isMobileView ? '6rem' : isCollapsed ? '100px' : '260px';
                pageContainer.style.width = isMobileView ? '' : isCollapsed ? 'calc(100% - 100px)' : 'calc(100% - 260px)';
            }

            if (topbar) {
                topbar.style.left = isMobileView ? '5rem' : isCollapsed ? '5.3rem' : '250px';
            }

            if (addPageContainer) {
                addPageContainer.style.left = isCollapsed ? '100px' : '180px';
                addPageContainer.style.width = isCollapsed ? 'calc(100% - 100px)' : 'calc(100% - 180px)';
            }
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        const observer = new ResizeObserver(([entry]) => {
            const currentHeight = entry.contentRect.height;
            const heightDifference = currentHeight - topbarHeightRef.current;
            const pageContainer = document.querySelector('.page-container');

            if (isMobileView && pageContainer) {
                const currentMarginTop = parseFloat(window.getComputedStyle(pageContainer).marginTop) || baseMarginTop;
                pageContainer.style.marginTop = `${currentMarginTop + heightDifference}px`;
            }

            topbarHeightRef.current = currentHeight;
        });

        if (topbar) observer.observe(topbar);

        return () => {
            window.removeEventListener('resize', handleResize);
            if (topbar) observer.unobserve(topbar);
        };
    }, [isCollapsed, location.pathname]);

    const NavLinkItem = ({ path, icon, label, isSubmenu, parentKey }) => (
        <SidebarMenu.Nav.Link
            key={path}
            as={Link}
            to={path}
            className={`${isSubmenu ? 'submenu-item' : 'menu-item'} ${location.pathname === path ? 'selected' : ''}`}
            onClick={() => {
                if (parentKey) {
                    setOpenSectionKey(parentKey);
                } else {
                    setOpenSectionKey(null);
                }
                if (isMobile) toggleNavbar();
            }}

        >
            <i className={`fas ${icon} ${isSubmenu ? 'submenu-icon' : 'menu-icon'}`}></i>
            {/*{!isCollapsed && label}*/}
            <span className="menu-label">{label}</span>
        </SidebarMenu.Nav.Link>
    );


    const renderMenuSection = ({submenu, title, icon, stateKey, paths }) => {
        const isOpen = openSectionKey === stateKey;

        if (submenu.length === 1) {
            return (
                <NavLinkItem
                    key={submenu[0].path} // 🔧 BURASI eksikti
                    {...submenu[0]}
                    isSubmenu={false}
                />
            );
        }


        return (
            <SidebarMenu.Sub key={stateKey}>
                <SidebarMenu.Sub.Toggle
                    className={`menu-item ${isOpen || isActiveMenu(paths) ? 'selected' : ''}`}
                    onClick={() => toggleSection(stateKey)}
                >
                    <i className={`fas ${icon} menu-icon`}></i> {!isCollapsed && title}
                    {!isCollapsed && (
                        <i className={`fas fa-chevron-right menu-arrow ${isOpen ? 'rotated' : ''}`}></i>
                    )}
                </SidebarMenu.Sub.Toggle>

                <SidebarMenu.Sub.Collapse in={isOpen}>
                    <SidebarMenu.Nav>
                        {submenu.map((item) => (
                            <NavLinkItem key={item.path} {...item} isSubmenu={true} parentKey={stateKey}/>
                        ))}
                    </SidebarMenu.Nav>
                </SidebarMenu.Sub.Collapse>
            </SidebarMenu.Sub>
        );
    };


    return (
        <div ref={useRef(null)} className={`navbar ${isCollapsed ? 'collapsed' : ''} ${isMobile ? 'mobile' : ''} ${isFixed ? 'fixed-navbar' : ''}`}>
            <SidebarMenu className="sidebar">
                <SidebarMenu.Toggle onClick={toggleNavbar} className={`sidebar-menu-toggle ${isCollapsed ? 'collapsed' : ''}`}>
                    <div className="bars">
                        {[...Array(3)].map((_, i) => (
                            <span key={i} className="bar"></span>
                        ))}
                    </div>
                </SidebarMenu.Toggle>

                <SidebarMenu.Body>
                    <div className="user-section">
                        <button onClick={handleLogout} className="logout-button">
                            <i className="fas fa-sign-out-alt"></i>
                            <span className={`logout-label ${isCollapsed ? 'collapsed' : ''}`}>Çıkış</span>
                        </button>
                    </div>


                    <SidebarMenu.Nav>
                        {menuItems.map(renderMenuSection)}
                    </SidebarMenu.Nav>
                </SidebarMenu.Body>

                {/*<div className="bottom-section">*/}
                {/*    <div className="help-section">*/}
                {/*        <button className="help-button" onClick={() => navigate('/admin/help-desk')}>*/}
                {/*            <i className="fas fa-question-circle"></i>*/}
                {/*        </button>*/}
                {/*    </div>*/}
                {/*    <div className="version-section">*/}
                {/*        <span className="version-number">V1.0</span>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </SidebarMenu>
        </div>
    );
};

export default AdminNavbar;